import { TermPinModel } from '../models/term_pin_model';
import { IDefineCommand, ICommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { TermPinServant } from '../servants/term_pin_servant';

export interface ITermPinData {
  term_pin: string;
}

export type GetTermPinCommand = (termId: number) => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .factory(
    'getTermPinCommand',
    (
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      log: any,
      ngTermPinModel: TermPinModel,
      ngTermPinServant: TermPinServant
    ): ICommand => {
      return defineCommandORM('getTermPinCommand', (deferred: ng.IDeferred<IQuery[]>, termId: number) => {
        if (ngTermPinServant.isTermPinFeatureEnabled()) {
          $http
            .get(`/reg/termpin/term/${termId}/`)
            .then((response: ng.IHttpPromiseCallbackArg<any>) => {
              const termPinData: ITermPinData = { term_pin: response.data.term_pin || '' };
              ngTermPinModel.clear().write(termPinData);
              deferred.resolve();
            })
            .catch(() => {
              log.issue('Failed to get the Term PIN');
              deferred.reject();
            });
        } else {
          deferred.resolve();
        }
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/term_pin/commands/get_term_pin_command.ts